import { CONFIG } from '../config/CONFIG.js';
import type { UIManagerInterface } from './types.js';

let uiLayer: HTMLElement | null = null;

export function initUIElements(layer: HTMLElement) {
  uiLayer = layer;
}

export const UIManager: UIManagerInterface = {
  uiTimer: null,

  showUI() {
    if (uiLayer) {
      uiLayer.style.opacity = '1';
    }
    if (this.uiTimer) {
      clearTimeout(this.uiTimer);
    }
    if (CONFIG.isPlaying) {
      this.uiTimer = setTimeout(() => {
        this.hideUI();
      }, 3000);
    }
  },

  hideUI() {
    if (uiLayer) {
      uiLayer.style.opacity = '0';
    }
  },

  setupAutoHide() {
    window.addEventListener('mousemove', () => {
      this.showUI();
    });
  },
};
